export const globalPromptChoices = [
	{ id: 'start', name: 'Start' },
	{ id: 'interview', name: 'Interview' },
	{ id: 'summary', name: 'Summary' },
	{ id: 'analyzetranscript', name: 'Analyze Transcript' }
];

export const modulePromptChoices = [
	{ id: 'start', name: 'Start' },
	{ id: 'interview', name: 'Interview' },
	{ id: 'summary', name: 'Summary' }
];
